import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { URLFilterStore } from '../../stores/BrowserPolicies/ContentFilteringStore';
import {
    ConsoleCard,
    ConsoleCardTitle,
} from '../ConsoleFragments';
import FuseInfoTooltip from '../FuseControls/FuseTooltip/FuseInfoTooltip';
import UrlBulkEditorCard from '../BulkEditor/UrlBulkEditorCard';

class FilterByUrl extends Component {
    static propTypes = {
        urlFilterStore: URLFilterStore.PropType.isRequired,
    };

    render() {
        const { urlFilterStore } = this.props;
        return <ConsoleCard>
            <ConsoleCardTitle>
                FILTER BY URL
                <FuseInfoTooltip inline>
                    Specify individual URLs to allow or block when a web page is requested.
                </FuseInfoTooltip>
            </ConsoleCardTitle>
            <div style={{ padding: '5px 20px' }}>
                <UrlBulkEditorCard
                    title={'Allowed URLs'}
                    subTitle={'Enter URL patterns below (1 entry per line)'}
                    validUrlText={'Allowed Entries'}
                    errorMassage={'Invalid URL pattern'}
                    placeholder="Enter or paste URL patterns"
                    store={urlFilterStore.allowedUrl}
                    legacyGuidelines
                /></div>
            <div style={{ padding: '0 20px' }}>
                <UrlBulkEditorCard
                    title={'Blocked URLs'}
                    validUrlText={'Blocked Entries'}
                    subTitle={'Enter URL patterns below (1 entry per line)'}
                    errorMassage={'Invalid URL pattern'}
                    placeholder="Enter or paste URL patterns"
                    store={urlFilterStore.blockedUrl}
                    legacyGuidelines
                /></div>
        </ConsoleCard>;
    }
}

export default observer(FilterByUrl);
